import { useMemo } from 'react';
import { useSessionStorage } from 'usehooks-ts';

import { eventCodes2506, KAKAO_EVENT_CODE_06 } from '@/consts/eventCode';

export const useSessionReferral = () => {
  return useSessionStorage('referral', '');
};

export const useSessionReferralDirect = () => {
  return useSessionStorage('referral_direct', false);
};

export const useSessionReferralBrandName = () => {
  return useSessionStorage('referral_brand_name', '');
};

export const useSessionSavedReferral = () => {
  return useSessionStorage('referral_saved', '');
};

export const useFromEventPage = () => {
  const [sessionReferral] = useSessionSavedReferral();
  const fromEventPage = useMemo(() => {
    if (!sessionReferral) {
      return false;
    }

    return eventCodes2506.includes(sessionReferral);
  }, [sessionReferral]);

  return fromEventPage;
};

export const useFromEventFunnel = () => {
  const [sessionReferral] = useSessionSavedReferral();
  const fromEventFunnel = useMemo(() => {
    switch (sessionReferral) {
      case '카뱅2503':
      case KAKAO_EVENT_CODE_06:
        return 'kakaobank';
      case '요기요2503':
      case '요기요2506':
        return 'yogiyo';
      default:
        return 'etc';
    }
  }, [sessionReferral]);

  return fromEventFunnel;
};
